// frontend/src/pages/AdminDashboard.tsx
import React, { useState, useEffect } from 'react';
import { Card, Table, Button, message, Space, Tag } from 'antd';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

interface Application {
  id: string;
  email: string;
  name: string;
  reason: string;
  status: string;
  appliedAt: any;
}

const AdminDashboard: React.FC = () => {
  const [applications, setApplications] = useState<Application[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchApplications = async () => {
    try {
      setLoading(true);
      const getPendingApplications = httpsCallable(functions, 'getPendingApplications');
      const result = await getPendingApplications();
      setApplications(result.data as Application[]);
    } catch (error: any) {
      message.error('載入申請失敗：' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReview = async (applicationId: string, approved: boolean) => {
    try {
      const reviewUserApplication = httpsCallable(functions, 'reviewUserApplication');
      await reviewUserApplication({
        applicationId,
        approved,
        adminNotes: approved ? '已批准' : '已拒絕'
      });
      
      message.success(approved ? '已批准申請' : '已拒絕申請');
      fetchApplications(); // 重新載入列表
    } catch (error: any) {
      message.error('操作失敗：' + error.message);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const columns = [
    {
      title: '電子郵件',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '申請理由',
      dataIndex: 'reason',
      key: 'reason',
    },
    {
      title: '狀態',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'pending' ? 'orange' : status === 'approved' ? 'green' : 'red'}>
          {status === 'pending' ? '待審核' : status === 'approved' ? '已批准' : '已拒絕'}
        </Tag>
      ),
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: Application) => (
        <Space>
          <Button
            type="primary"
            size="small"
            onClick={() => handleReview(record.id, true)}
          >
            批准
          </Button>
          <Button
            danger
            size="small"
            onClick={() => handleReview(record.id, false)}
          >
            拒絕
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Card title="用戶申請管理">
        <Button 
          type="primary" 
          onClick={fetchApplications} 
          loading={loading}
          style={{ marginBottom: 16 }}
        >
          重新載入
        </Button>
        <Table
          columns={columns}
          dataSource={applications}
          rowKey="id"
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default AdminDashboard;
